export * from "./getAlternativeVariantsColors";
